import axios from "axios";
import userService from "@/services/UserService/userService.js";
const state = {
  loginResponse: {},
  updatepwdResponse: {},
  forgotResponse: {},
  validOTPResponse: {},
  base_url: process.env.VUE_APP_BASEURL_NEW,
  user_port: process.env.VUE_APP_USER_PORT,
};

const mutations = {
  loginAccount(state, payload) {
    switch (payload.type) {
      case "LOGING_ACCOUNT":
        state.loginResponse = {
          isLoging: true,
          errorRegistering: false,
          loginData: {},
        };
        break;
      case "LOGIN_ACCOUNT":
        state.loginResponse = {
          isLoging: false,
          errorRegistering: false,
          loginData: payload.data,
        };
        break;
    }
  },
  updatePassword(state, payload) {
    switch (payload.type) {
      case "UPDATING_PASSWORD":
        state.updatepwdResponse = {
          isLoging: true,
          errorRegistering: false,
          password: {},
        };
        break;
      case "UPDATE_PASSWORD":
        state.updatepwdResponse = {
          isLoging: false,
          errorRegistering: false,
          password: payload.data,
        };
        break;
    }
  },
  updateLanguage(state, payload) {
    switch (payload.type) {
      case "UPDATE_LANGUAGE":
        state.language = payload.data;
        break;
    }
  },

  updateProfile(state, payload) {
    switch (payload.type) {
      case "UPDATING_PROFILE":
        state.profileResponse = {
          isLoging: true,
          errorRegistering: false,
          profile: {},
        };
        break;
      case "UPDATE_PROFILE":
        state.profileResponse = {
          isLoging: false,
          errorRegistering: false,
          profile: payload.data,
        };
        break;
    }
  },
  forgotPassowrd(state, payload) {
    switch (payload.type) {
      case "FORGOT_PASSWORD":
        state.forgotResponse = {
          isLoging: false,
          errorRegistering: false,
          data: payload.data,
        };
        break;
    }
  },
  validOTP(state, payload) {
    switch (payload.type) {
      case "VALID_OTP":
        state.validOTPResponse = {
          isLoging: false,
          errorRegistering: false,
          data: payload.data,
        };
        break;
    }
  },
};

const getters = {
  getLoginData: (state) => state.loginResponse,
};

const actions = {
  saveUserEmail({ commit }, _userEmail) {
    commit("user_email", _userEmail);
  },
  async login({ commit }, _userDetails) {
    try {
      const responseData = await userService.Login(_userDetails);
      if (responseData && responseData.success) {
        // ... Handle successful login response
        commit("loginAccount", { type: "LOGIN_ACCOUNT", data: responseData });
        return responseData;
      } else {
        // Handle unsuccessful login response
        return { error: responseData.message };
      }
    } catch (error) {
      console.error(error);
      return { error: "An error occurred during login." };
    }
  },
  async forgotPassword({ commit }, _userDetails) {
    try {
      const User_Email = _userDetails.User_Email;
      const responseData = await userService.TwoFA(User_Email);
      commit("forgotPassowrd", { type: "FORGOT_PASSWORD", data: responseData });
      return responseData;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async validateOtpPassword({ commit }, _otpDetails) {
    try {
      const User_Email = _otpDetails.email;
      const otpValue = _otpDetails.otpPassword;
      const responseData = await userService.OTPverification(
        User_Email,
        otpValue
      );
      commit("validOTP", { type: "VALID_OTP", data: responseData });
      return responseData;
    } catch (e) {
      return e;
    }
  },
  async changePassword({ commit }, _userDetails) {
    console.log("userDetao", _userDetails);
    try {
      const responseData = await axios.post(
        `${state.base_url}/api/v1/user/forget_password`,
        _userDetails
      );
      commit("updatePassword", { type: "UPDATE_PASSWORD", data: responseData });
      console.log("store", responseData);
      return responseData;
    } catch (e) {
      return e;
    }
  },
  async getCountryService({ commit }) {
    try {
      const token = sessionStorage.getItem("access_token");
      const responseData = await axios.get(
        `http://3.111.47.115:5000/api/v1/user/all-countries`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      commit("updatePassword", {
        type: "UPDATE_PASSWORD",
        data: responseData.data,
      });
      return responseData;
    } catch (e) {
      return e;
    }
  },
  async getStateById({ commit }, id) {
    try {
      const token = sessionStorage.getItem("access_token");
      const responseData = await axios.get(
        `${state.base_url}/api/v1/user/all-states?country_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      commit("updatePassword", {
        type: "UPDATE_PASSWORD",
        data: responseData.data,
      });
      return responseData.data;
    } catch (e) {
      return e;
    }
  },
  async getCityById({ commit }, id) {
    try {
      const token = sessionStorage.getItem("access_token");
      const responseData = await axios.get(
        `${state.base_url}/api/v1/user/all-cities?state_id=${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      commit("getCityList", { type: "GET_CITY_LIST", data: responseData.data });
      return responseData;
    } catch (e) {
      return e;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
